// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__bB21v","info":"PatientInfo_info__2JHon"};